export default __webpack_public_path__ + "static/media/illustrator-2.9259cd89.png";